






























import { Component, Vue } from "vue-property-decorator";
import headerTitle from "@/components/headerTitle.vue";
import baseOption from "./base/baseOption.vue";
import baseNav from "./base/baseNav.vue";
import baseEcharts from "./base/baseEcharts.vue";
import baseTab from "./base/baseTab.vue";
import echarts from "echarts";
import { headStatistics, statistics } from "@/req/dataIndex";
@Component({
  components: { headerTitle, baseOption, baseNav, baseEcharts, baseTab },
})
export default class Home extends Vue {
  // 顶部筛选
  public baseList: any = {
    timeListId: 0,
    stime: "",
    stimes: "",
    etime: "",
    etimes: "",
    timeShow: false,
    gameId: "",
    serverId: "",
    platformId: "",
  };
  // 中部筛选
  public navListActive = 0;
  public navList: any = [
    {
      name_one: "交易总额",
      num_one: 0,
      decimal: 2,
      name_two: "交易笔数",
      num_two: 0,
      decimals: 0,
      tips: "交易总额: 为交易行今天的收入  交易笔数: 为交易行今天的交易笔数",
    },
    {
      name_one: "当前在售",
      num_one: 0,
      decimal: 0,
      name_two: "今日上架",
      num_two: 0,
      decimals: 0,
      tips:
        "当前在售: 今日交易行在售中的商品  交易笔数: 今日交易行中上架的商品",
    },
    {
      name_one: "公司收入",
      num_one: 0,
      decimal: 2,
      name_two: "GM  收入",
      num_two: 0,
      decimals: 2,
      tips:
        "每次交易成功都会产生服务费，根据后台对游戏的配比，统计出对应时间段公司和gm的收入",
    },
  ];
  public tabColumn = [
    {
      title: "排名",
      type: "index",
      width: 70,
      align: "center",
    },
    {
      title: "游戏名",
      key: "game_name",
      align: "center",
    },
    {
      title: "交易总额",
      key: "total_amount",
      align: "center",
    },
  ];
  public tabColumns = [
    {
      title: "排名",
      type: "index",
      width: 70,
      align: "center",
    },
    {
      title: "游戏名",
      key: "game_name",
      align: "center",
    },
    {
      title: "交易笔数",
      key: "total_count",
      align: "center",
    },
  ];
  public tabList: any = [];
  public tabLists: any = [];
  // echarts数据
  public nowList: any = [];
  public pastList: any = [];
  public dataList: any = [];
  public mounted() {
    this.getList();
  }
  // 接收筛选返回数据
  public getBaseOption(baseList) {
    this.baseList = baseList;
    if (this.baseList.timeListId == 0) {
      this.navList[0].tips =
        "交易总额: 为交易行今天的收入  交易笔数: 为交易行今天的交易笔数";
      this.navList[1].tips =
        "当前在售: 今日交易行在售中的商品  交易笔数: 今日交易行中上架的商品";
      this.navList[1].name_two = "今日上架";
    }
    if (this.baseList.timeListId == 1) {
      this.navList[0].tips =
        "交易总额: 为交易行最近30天的收入  交易笔数: 为交易行最近30天的交易笔数";
      this.navList[1].tips =
        "当前在售: 最近30天交易行在售中的商品  交易笔数: 最近30天交易行中上架的商品";
      this.navList[1].name_two = "本月上架";
    }
    this.getList();
  }
  // 接收NAV返回数据
  public getBaseNav(index) {
    this.navListActive = index;
    this.tabColumn[2].title = this.navList[index].name_one;
    this.tabColumns[2].title = this.navList[index].name_two;
    // this.getList()
    this.getEcharts();
  }
  public async getList() {
    this.tabList = [];
    this.tabLists = [];
    const res = await headStatistics({
      token: this.$fn.cookies.getToken("token"),
      type: this.baseList.timeListId,
      start_time: this.baseList.stime,
      end_time: this.baseList.etime,
      game_id: this.baseList.gameId == undefined ? "" : this.baseList.gameId,
      server_id:
        this.baseList.serverId == undefined ? "" : this.baseList.serverId,
    });
    if (res.code == 0) {
      this.getEchartsList();
      this.navList[0].num_one = res.data.all_transaction;
      this.navList[0].num_two = res.data.count_transaction;
      this.navList[1].num_one = res.data.on_sell;
      this.navList[1].num_two = res.data.today_shelves;
      this.navList[2].num_one = res.data.company_income;
      this.navList[2].num_two = res.data.gm_income;
    }
  }
  public async getEchartsList() {
    const res = await statistics({
      token: this.$fn.cookies.getToken("token"),
      type: this.baseList.timeListId,
      start_time: this.baseList.stime,
      end_time: this.baseList.etime,
      game_id: this.baseList.gameId == undefined ? "" : this.baseList.gameId,
      server_id:
        this.baseList.serverId == undefined ? "" : this.baseList.serverId,
    });
    if (res.code == 0) {
      this.dataList = res.data;
      this.getEcharts();
    }
  }
  // 数据传入echarts
  public getEcharts() {
    const $baseEcharts: any = this.$refs.baseEcharts;
    const $baseEchartss: any = this.$refs.baseEchartss;
    if (this.navListActive == 0) {
      this.tabColumn[2].key = "total_amount";
      this.tabColumns[2].key = "total_count";
      this.tabList = this.dataList.all_transaction_log.game_rank;
      this.tabLists = this.dataList.count_transaction_log.game_rank;
      this.nowList = this.dataList.all_transaction_log.all_transaction;
      this.pastList = this.dataList.count_transaction_log.count_transaction;
      $baseEcharts.show(
        this.nowList,
        [],
        this.baseList.timeListId,
        this.navList[this.navListActive].name_one,
        1
      );
      $baseEchartss.show(
        this.pastList,
        [],
        this.baseList.timeListId,
        this.navList[this.navListActive].name_two,
        1
      );
    }
    if (this.navListActive == 1) {
      this.tabColumn[2].key = "game_count";
      this.tabColumns[2].key = "game_count";
      this.tabList = this.dataList.on_sell_log.game_rank;
      this.tabLists = this.dataList.today_shelves_log.game_rank;
      this.nowList = this.dataList.on_sell_log.on_sell;
      this.pastList = this.dataList.today_shelves_log.today_shelves;
      $baseEcharts.show(
        this.nowList,
        [],
        this.baseList.timeListId,
        this.navList[this.navListActive].name_one,
        1
      );
      $baseEchartss.show(
        this.pastList,
        [],
        this.baseList.timeListId,
        this.navList[this.navListActive].name_two,
        2
      );
    }
    if (this.navListActive == 2) {
      this.tabColumn[2].key = "total_service_amount";
      this.tabColumns[2].key = "total_gm_amount";
      this.tabList = this.dataList.company_income_log.game_rank;
      this.tabLists = this.dataList.gm_income_log.game_rank;
      this.nowList = this.dataList.company_income_log.company_income;
      this.pastList = this.dataList.gm_income_log.gm_income;
      $baseEcharts.show(
        this.nowList,
        [],
        this.baseList.timeListId,
        this.navList[this.navListActive].name_one,
        1
      );
      $baseEchartss.show(
        this.pastList,
        [],
        this.baseList.timeListId,
        this.navList[this.navListActive].name_two,
        1
      );
    }
  }
}
